function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: a , size: r = 24  } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = s(), l = a !== null && a !== void 0 ? a : i ? t.colors.inverse : t.colors.neutralHigh, { skinName: n  } = c();
    return n.match(/^blau/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: l,
            d: "M6.314 6.615h10.682L13.852 9.76l3.144 3.145H6.314v-6.29zm9.462 3.145l4.504-4.505H6.314v-.228c.838-.42 1.258-1.55.458-2.6-1.712-1.304-3.648.632-2.344 2.344.174.133.351.224.526.294V22h1.36v-7.735H20.28L15.776 9.76z"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: l,
            d: "M17.19 7.407c-.065.062-.062.163.002.23l3.098 3.095c.353.454.407.98.182 1.432a1.312 1.312 0 01-1.182.73H4.542v8.37c0 .317-.26.575-.58.575a.578.578 0 01-.58-.574V3.463c0-.72.592-1.308 1.317-1.308H19.29c.507 0 .958.28 1.182.731.224.451.171.978-.134 1.376l-3.149 3.145zm2.1 4.34a.152.152 0 00.143-.09.147.147 0 00-.017-.166l-3.05-3.044a1.317 1.317 0 01.003-1.852l3.1-3.087a.463.463 0 00-.033-.11.152.152 0 00-.143-.089H4.703c-.09 0-.16.07-.16.157v8.28H19.29z"
        })
    }));
}, p = h;
export { p as default };
